import trophy from '../assets/img/Frame 151.svg'
import record from '../assets/img/records.svg'
import barchart from '../assets/img/barchart.svg'
import verified from '../assets/img/verifiedIcon.svg'

const features = [
    {
        index: 0,
        image: trophy,
        feature: 'Ensure alignment of individual goals with overall company objectives'
    },
    {
        index: 1,
        image: record,
        feature: 'Monitor and record of employee progress towards goals'
    },
    {
        index: 2,
        image: barchart,
        feature: 'Visualize performance data to identify areas for improvement'
    },
    {
        index: 3,
        image: verified,
        feature: 'Conducting regular performance evaluations and providing feedback'
    }
]
export default features